import "./Libros.scss";

import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import ls from "../../services/localStorage";
import Menu from "../../components/Menu/Menu";
import { MenuProps } from "../../components/Menu/MenuTypes";
import { defaultMenuProps } from "../../constants/constants";
import { getApiBook, getApiBooks, getApiBooksActions, putApiUpdateBook } from "../../services/apiBook";
import { types } from "../../constants/constants";
import { TableProps } from "../../components/Table/TableTypes";
import Table from "../../components/Table/Table";
import Button from "../../components/Button/Button";
import dayjs from "dayjs";
import { Modal } from "react-bootstrap";
import 'dayjs/locale/es' // import locale
import InputText from "../../components/InputText/InputText";
import Papa from "papaparse";


const Libros = (): React.ReactElement =>{  
  const navigate = useNavigate();
  const [menuProps, setMenuProps] = useState<MenuProps>(defaultMenuProps);
  const [books, setBooks] = useState<TableProps['items']>([]);
  const [limit, setLimit] = useState<number>(types.PAGE_SIZE);
  const [offset, setOffset] = useState<number>(0);
  const [totalBooks, setTotalBooks] = useState<number>(0);
  const [actions, setActions] = useState<TableProps["actions"]>([]);
  const [sortDirection, setSortDirection] = useState<number>(1);
  const [sortBy, setSortBy] = useState<string>('created_at');
  const [modalISBN, setModalISBN] = useState<boolean>(false);
  const [modalData, setModalData] = useState<boolean>(false);
  const [bookIdISBN, setBookIdISBN] = useState<string>('');
  const [bookIdData, setBookIdData] = useState<string>('');
  const [bookData, setBookData] = useState<any>('');
  const [bookActionsData, setBookActionsData] = useState<any>([]);
  const [codeISBN, setCodeISBN] = useState<string>('');
  const [saving, setSaving] = useState<boolean>(false);
  const [formErrors, setFormErrors] = useState<any>();
  const [formFeedback, setFormFeedback] = useState<any>();

  useEffect(() => {
    //getBooks();

    setActions([
      {
        name : 'Cambiar ISBN',
        onClick : editISBN,
        icon : 'write' 
      },
      {
        name : 'Ver histórico',
        onClick : viewData,
        icon : 'eye'
      },
      /*{
        name : 'Editar',
        onClick : editAction,
        icon : 'pencil' 
      },
      {
        name : 'Borrar',
        onClick : deleteAction,
        icon : 'deleteIcon' 
      }*/
    ])
  }, []);

  useEffect(() => {
    getBooks();
  }, [sortBy, sortDirection]);

  const getBooks = async (): Promise<void> => {
    const result: object = getApiBooks(
      {
        limit: limit,
        offset: offset,
        sortBy: sortBy,
        sortDirection: sortDirection
      }
    ).then(async (response: any) => {
      setTotalBooks(response.total)

      const resultsBooks: TableProps['items'] = await Promise.all(response.books && response.books.map((book: any, index: number) =>{
        return [
          { name: '#', value : index + 1 },
          { name: 'Id', value : book._id },
          { name: 'Título', value : book.title, sortable: true, index: 'title' },
          { name: 'Autor', value : `${book.user.firstName} ${book.user.lastName}`},
          { name: 'ISBN', value : `${book.isbn}`},
          { name: 'Concurso', value : `${book.isbn_promo ? true : false}`, sortable: true, index: 'isbn_promo', className: 'text-center'},
          { name: 'Precio', value : book.price ? `${book.price.toString().replace('.', ',')}€` : '--', sortable: true, index: 'price', className: 'text-center' },
          { name: 'Ventas', value : book.sales, className: 'text-center' },
          { name: 'Visto', value : book.views, sortable: true, index: 'views', className: 'text-center' },
          { name: 'Publicado', value : dayjs(book.created_at).format('DD/MM/YYYY'), sortable: true, index: 'created_at', className: 'text-center' }
        ]
      }));
      setBooks(resultsBooks);
    })
    .catch((error: any) => {
      console.log(error.message);
      setBooks([])
    });
  }

  const loadMoreBooks = async (): Promise<void> => {
    const offsetPage = offset + limit;
    
    const result: object = getApiBooks(
      {
        limit: limit,
        offset: offsetPage,
        sortBy: sortBy,
        sortDirection: sortDirection
      }
    ).then(async (response: any) => {
      const resultsBooks: TableProps['items'] = await Promise.all(response.books && response.books.map((book: any, index: number) =>{
        return [
          { name: '#', value : index + offsetPage + 1 },
          { name: 'Id', value : book._id },
          { name: 'Título', value : book.title, sortable: true, index: 'title' },
          { name: 'Autor', value : `${book.user.firstName} ${book.user.lastName}`},
          { name: 'ISBN', value : `${book.isbn}`},
          { name: 'Concurso', value : `${book.isbn_promo ? true : false}`, sortable: true, index: 'isbn_promo', className: 'text-center'},
          { name: 'Precio', value : book.price ? `${book.price.toString().replace('.', ',')}€` : '--', sortable: true, index: 'price', className: 'text-center' },
          { name: 'Ventas', value : book.sales, className: 'text-center' },
          { name: 'Visto', value : book.views, sortable: true, index: 'views', className: 'text-center' },
          { name: 'Publicado', value : dayjs(book.created_at).format('DD/MM/YYYY'), sortable: true, index: 'created_at', className: 'text-center' }
        ]
      }));
      
      const arrayBooks = books.concat(resultsBooks)
      setOffset(offsetPage);
      setBooks(arrayBooks);
    })
    .catch((error: any) => {
      console.log(error.message);
      setBooks([])
    });
  }

  const editAction = (id: string): void => {
    navigate(`/libros/${ id }`);
  }

  const deleteAction = (id: string): void => {
    alert('delete');
  }
  
  const editISBN = (id: string): void => {
    setFormFeedback((formFeedback: any) => Object.assign({}));
    setModalISBN(true);
    setBookIdISBN(id);
  }
  
  const viewData = async (id: string): Promise<void> => {
    setBookIdData(id);
    const book: object = await getApiBook({'_id' : id});
    const bookActions: any = await getApiBooksActions({'_id' : id});
    setBookData(book);
    setBookActionsData(bookActions.actions);
    setModalData(true);
  }
  
  const saveISBN = async(): Promise<void> => {
    setSaving(true);
    try{
      let error = false;
      setFormErrors((formErrors: any) => Object.assign({}));
      
      if (!codeISBN || codeISBN == '') {
        setFormErrors((formErrors: any) => Object.assign({}, formErrors, { isbn: "Tienes que introducir el código" }));
        error = true;
      }
         
      if(!error){
        const token = ls.get("token");
        setFormErrors((formErrors: any) => Object.assign({}, formErrors, { form : "" }));

        const attributes: any = {
          book: {
            _id: bookIdISBN,
            isbn: codeISBN
          }
        }
      
        attributes.book._id = bookIdISBN
        const result: object = putApiUpdateBook(attributes)
        .then(async (response: any) => {
          setSaving(false)
          getBooks()
          setFormFeedback((formFeedback: any) => Object.assign({}, formFeedback, { isbn: "El ISBN se ha actualizado" }));
        })
        .catch((error: any) => {
          setSaving(false)
          console.log(error.message);
        });

      }else{
        setFormErrors((formErrors: any) => Object.assign({}, formErrors, { form : "Hay errores en el formulario" }));
        console.log(formErrors)
        setSaving(false)
      }
    }catch(error: any) {
      alert(error.stack);
    }
  
    setSaving(false);
  }

  const doSortBy = (field : string): void => {
    setOffset(0)
    setSortBy(field)
    setSortDirection(sortDirection === 1 ? -1 : 1)
  }
  
  const exportToCSV = () => {
    const result: object = getApiBooks(
      {}
    ).then(async (response: any) => {

      const resultsBooks: TableProps['items'] = await Promise.all(response.books && response.books.map((book: any, index: number) =>{
        return [
          { name: '#', value : index + 1 },
          { name: 'Id', value : book._id },
          { name: 'Título', value : book.title, sortable: true, index: 'title' },
          { name: 'Autor', value : `${book.user.firstName} ${book.user.lastName}`},
          { name: 'ISBN', value : `${book.isbn}`},
          { name: 'Concurso', value : `${book.isbn_promo ? true : false}`, sortable: true, index: 'isbn_promo', className: 'text-center'},
          { name: 'Precio', value : book.price ? `${book.price.toString().replace('.', ',')}€` : '--', sortable: true, index: 'price', className: 'text-center' },
          { name: 'Ventas', value : book.sales, className: 'text-center' },
          { name: 'Visto', value : book.views, sortable: true, index: 'views', className: 'text-center' },
          { name: 'Publicado', value : dayjs(book.created_at).format('DD/MM/YYYY'), sortable: true, index: 'created_at', className: 'text-center' }
        ]
      }));
        
      const flatData = resultsBooks.map((row): { [key: string]: any } => {
        const obj: { [key: string]: any } = {};
        row.forEach(cell => {
          obj[cell.name] = cell.value;
        });
        return obj;
      });
      
      const csv = Papa.unparse(flatData);
      
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "obras_bookolicos.csv");
      document.body.appendChild(link);
      link.click();
    });
  }
  
  return(
    <React.Fragment>
      <div id="menu">
        <Menu items={ menuProps.items } />
      </div>

      <div id="app-content">
        <header className="table-header mb-4">
          <h1>Libros</h1>
          <div className="text-right">
            <span>Total registros: { totalBooks }</span><br />
            <a className="pointer" onClick={ exportToCSV }>Descargar csv</a>
          </div>
        </header>
        { books && books.length ?
          <Table items={ books } actions={actions} doSortBy={doSortBy} />
        :
          <p>No hay libros</p>
        }

        { totalBooks > books.length ?
          <div className="row mt-4">
            <div className="col-12 col-md-4 offset-md-4">
              <Button className={'btn-white m-auto'} value={'Cargar más'} onClick={ () => { loadMoreBooks() } } />
            </div>
          </div>
        : null }
      </div>
      
      <Modal size="sm" show={modalISBN} centered={true} onHide={() => { setModalISBN(false) }}>
        <Modal.Header closeButton>
          <Modal.Title>Cambiar ISBN</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-3">
            <InputText
            label="Introduce el nuevo ISBN"
            value={''}
            placeholder="Escribe el ISBN"
            onChange={(event: any) => { setCodeISBN(event.currentTarget.value) }} />
          </div>

          { formErrors && formErrors.isbn &&
            <p className="error text-center">{ formErrors.isbn }</p>
          }
          
          { formFeedback && formFeedback.isbn &&
            <p className="success text-center">{ formFeedback.isbn }</p>
          }
          
          <Button value="Guardar" className="btn-orange mx-auto mt-4 mb-3" onClick={saveISBN} iconRight={ saving ? 'loaderIcon' : '' } />        
        </Modal.Body>
      </Modal>
      
      <Modal size="lg" show={modalData} centered={true} onHide={() => { setModalData(false) }}>
        <Modal.Header closeButton>
          <Modal.Title>Datos del libro</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col">
              <div className="row">
                <div className="col-auto"><b>Título: </b></div>
                <div className="col">{bookData.title}</div>
              </div> 
              <div className="row mb-2">
                <div className="col">{bookData.summary}</div>
              </div> 
              <div className="row mb-2">
                <div className="col-auto"><b>ISBN: </b></div>
                <div className="col">{bookData.isbn}</div>
              </div>
              <div className="row mb-2">
                <div className="col-auto"><b>Precio: </b></div>
                <div className="col">{bookData.price}€</div>
              </div>
              <div className="row mb-2">
                <div className="col"><a href={bookData.file} target="_blank">Descargar libro</a></div>
              </div>
            </div>
            <div className="col-auto">
              <img src={bookData.picture_thumb} width={150} />
            </div>
          </div>
          
          <hr />
          
          <div className="row">
            <div className="col"><h4 className="mt-2 mb-0">Acciones ({bookActionsData.length})</h4></div>
          </div>
          
          <hr />
          
          <div className="row">
            { bookActionsData.length ? 
              bookActionsData.map((action: any) => (
                <React.Fragment>
                  <div className="row mb-2">
                    <div className="col"><h6 className="underlined">{ action.type }</h6></div>
                    <div className="col-auto text-right"><h6>{ dayjs(action.date).format('DD/MM/YYYY HH:MM') }h</h6></div>
                  </div>
                    
                  <div className="row">
                    { action.type == 'Actualización' ?
                      <div className="row">
                        <div className="col">
                          <div className="row">
                            <div className="col-auto"><b>Título: </b></div>
                            <div className="col">{action.title}</div>
                          </div> 
                          
                          <div className="row">
                            <div className="col-auto"><b>Sinopsis: </b></div>
                            <div className="col">{action.summary}</div>
                          </div> 
                          
                          <div className="row">
                            <div className="col-auto"><b>ISBN: </b></div>
                            <div className="col">{action.isbn}</div>
                          </div> 
                          
                          <div className="row">
                            <div className="col-auto"><b>Price: </b></div>
                            <div className="col">{(action.price).toString().replace('.', ',')}€</div>
                          </div> 
                        </div>
                      </div>
                    : null }
                    
                    { action.type == 'Venta' ?
                      <div className="row">
                        <div className="col">
                          <div className="row">
                            <div className="col-auto"><b>Comprador: </b></div>
                            <div className="col">{action.customer}</div>
                            <div className="col-auto"><b>Vendedor: </b></div>
                            <div className="col">{action.seller}</div>
                            <div className="col-auto"><b>Precio: </b></div>
                            <div className="col">{(action.amount/100).toString().replace('.', ',')}€</div>
                          </div> 
                          
                          <div className="row">
                            <div className="col-auto"><b>Payment intent: </b></div>
                            <div className="col">{action.payment_intent}</div>
                          </div> 
                        </div>
                      </div>
                    : null }
                  </div>
                  
                  <hr className="mt-3 mx-2" />
                </React.Fragment>
              ))
            : 
              <p>No hay acciones</p>
            }
          </div>
            
        </Modal.Body>
      </Modal>
    </React.Fragment>
  )
}

export default Libros;